import { ReactNode, useEffect } from 'react';
import { createContext } from 'react';
import { CurrencyTypeEnum, VolSurfaceToken } from '../../../../model/currency_type.enum';
import usePersistentState from '../../../../providers/use-persistent-state';

interface IWidgetProvider {
  children?: ReactNode;
  defaultToken?: VolSurfaceToken;
  providerKey?: string;
}

interface IWidgetContext {
  token: VolSurfaceToken;
  setToken: React.Dispatch<React.SetStateAction<VolSurfaceToken>>;
  hasDefaultToken: boolean;
}

export const WidgetContext = createContext({} as IWidgetContext);

export const WidgetProvider = (props: IWidgetProvider) => {
  const { defaultToken, children, providerKey } = props;

  const STATE_PATH = providerKey ? [`WIDGET_${providerKey}`] : ['WIDGET'];

  const [token, setToken] = usePersistentState<VolSurfaceToken>(
    STATE_PATH,
    'token',
    defaultToken || CurrencyTypeEnum.BITCOIN,
  );

  useEffect(() => {
    if (defaultToken && defaultToken !== token) {
      setToken(defaultToken || CurrencyTypeEnum.BITCOIN);
    }
  }, [defaultToken]);

  return (
    <WidgetContext.Provider
      value={{
        token,
        setToken,
        hasDefaultToken: !!defaultToken,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
